import { FreeBetData, TAdvancedFreebet } from 'interfaces/bet-data';
import { buildFreeBetArgsFromBets } from 'newelements/_Betslip/managers/FreeBetManager/utils/build-free-bet-args-from-bets';
import { fetchFreeBetAmounts } from 'newelements/_Betslip/managers/FreeBetManager/utils/fetchFreeBetAmounts/index';
import { fireCheckProfitBoost } from 'newelements/_Betslip/managers/ProfitBoostManager/actions';
import store from 'store';
import { setFreeBetField, updateSingleEvents } from 'store/actions';
import { IBetslipRootStateInitialData } from 'store/reducers/betslip';

export const getSingleEventsFreeBets = () => {
  const betslipStore: IBetslipRootStateInitialData = store.getState()?.betSlip;

  const allBets = betslipStore.allLsBets;
  const freeBetStore = betslipStore.freeBets;

  const singleEventFreeBets: FreeBetData = {};

  const getFreeBetPromises = allBets.reduce<
    ReturnType<typeof fetchFreeBetAmounts>[]
  >((promises, bet) => {
    if (freeBetStore.singleEventFreeBets[bet.eventId]) {
      return promises;
    }

    const [events, isLive] = buildFreeBetArgsFromBets([bet]);

    const callback = (data: TAdvancedFreebet[]) =>
      fireCheckProfitBoost(data, bet.eventId);

    const amountsPromise = fetchFreeBetAmounts({
      events,
      isLive,
      callback
    });

    amountsPromise.then(amounts => {
      singleEventFreeBets[bet.eventId] = amounts;
    });

    return [...promises, amountsPromise];
  }, []);

  if (
    freeBetStore.selectedFreeBetEventId &&
    !allBets.find(bet => bet.eventId === freeBetStore.selectedFreeBetEventId)
  ) {
    store.dispatch(
      setFreeBetField({
        selectedFreeBetEventId: null
      })
    );
  }

  Promise.all(getFreeBetPromises).finally(() => {
    store.dispatch(updateSingleEvents(singleEventFreeBets));
  });
};
